var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6676_6176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.22667 0H21.7733C22.4511 0 23 0.912102 23 2.03822V21.9618C23 23.0879 22.4511 24 21.7733 24H1.22667C0.548933 24 0 23.0879 0 21.9618V2.03822C0 0.912102 0.548933 0 1.22667 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.97041 9.61024C5.18347 9.53833 5.41221 9.50081 5.65034 9.50081C6.69061 9.50081 7.55854 10.2387 7.75594 11.2174L9.22861 10.9172C8.89021 9.2538 7.41754 8 5.65034 8C5.24614 8 4.85761 8.06566 4.49414 8.1876L4.97041 9.61024Z",
    fill: "#FFF100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2314 14.3757L4.2278 13.2501C3.78287 12.8561 3.504 12.2839 3.504 11.643C3.504 11.0051 3.78287 10.4298 4.2278 10.039L3.2314 8.9165C2.47627 9.58561 2 10.558 2 11.6461C2 12.7311 2.47627 13.7066 3.2314 14.3757Z",
    fill: "#00A3DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75614 12.0742C7.55561 13.0529 6.69081 13.7876 5.65054 13.7876C5.41241 13.7876 5.18368 13.7501 4.96748 13.6782L4.49121 15.1008C4.85468 15.2228 5.24634 15.2884 5.65054 15.2884C7.41774 15.2884 8.89041 14.0378 9.22881 12.3744L7.75614 12.0742Z",
    fill: "#EE4023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1348 13.081C13.8904 13.3187 13.5615 13.4625 13.198 13.4562C12.9473 13.4531 12.7155 13.3781 12.5212 13.253L12.0324 14.0284C12.3677 14.2379 12.7593 14.363 13.1855 14.3692C13.8027 14.3786 14.3667 14.1347 14.7772 13.7376L14.1348 13.081ZM13.2513 9.91997C12.023 9.90121 11.0078 10.883 10.989 12.1086C10.9827 12.5683 11.1143 12.9998 11.3493 13.3562L15.3851 11.6334C15.1595 10.6672 14.2947 9.93873 13.2513 9.91997ZM11.9133 12.2837C11.9071 12.2337 11.9039 12.1806 11.9039 12.1274C11.9165 11.4051 12.5118 10.8267 13.2356 10.8392C13.6304 10.8455 13.9813 11.0237 14.2163 11.3051L11.9133 12.2837ZM16.6541 8.91943V13.2124L17.3998 13.5219L17.0457 14.3692L16.3062 14.0628C16.1402 13.9909 16.0274 13.8815 15.9428 13.7564C15.8613 13.6313 15.7987 13.4562 15.7987 13.2249V8.91943H16.6541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3459 10.9046C19.4775 10.8609 19.6154 10.839 19.7627 10.839C20.3987 10.839 20.9251 11.2892 21.0473 11.8864L21.9466 11.7019C21.7398 10.6858 20.8405 9.92285 19.7627 9.92285C19.5151 9.92285 19.277 9.9635 19.0577 10.0354L19.3459 10.9046ZM18.2837 13.8093L18.8916 13.1246C18.619 12.8838 18.4498 12.5336 18.4498 12.1428C18.4498 11.752 18.6221 11.4018 18.8916 11.1641L18.2837 10.4794C17.8231 10.8859 17.5317 11.4831 17.5317 12.1459C17.5317 12.8088 17.8231 13.4028 18.2837 13.8093ZM21.0473 12.4086C20.9251 13.0058 20.3956 13.456 19.7627 13.456C19.6185 13.456 19.4775 13.431 19.3459 13.3872L19.0545 14.2564C19.277 14.3315 19.5151 14.3721 19.7627 14.3721C20.8405 14.3721 21.7398 13.6092 21.9466 12.593L21.0473 12.4086Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6676_6176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 24,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElo);
export default __webpack_public_path__ + "static/media/elo.96d5a498d613de3d6540bdbbed8891fa.svg";
export { ForwardRef as ReactComponent };